/**
 * Revision History
 * 
 * 211124 ptkim     Create
 */
import { SQLField } from "./SQLInfo";

interface IDBMappingInfo {
  field: string,
  table: string,
  tbName?: string,
  tbId?: string,
  type?: number,
  c1?: string,
  name?: string
}
export class DBMappingInfo {
  dbField: string = '';
  dbTable: string = '';
  dbParams: SQLField[] = [];

  constructor(init?: IDBMappingInfo) {
    //Object.apply(this, init);
    if(init) {
      this.dbField = init.field;
      this.dbTable = init.table;

      if(init.name) {
        this.dbParams.push(new SQLField({ fieldName: "F_Name", value: init.name }));
      } else if(init.tbName && init.tbId) {
        this.dbParams.push(
          new SQLField({fieldName: "F_TBName", value: init.tbName }),
          new SQLField({fieldName: "F_TBId", value: init.tbId})
        );

        if(init.type !== undefined)
          this.dbParams.push(new SQLField({ fieldName: "F_Type", value: init.type }));
        if(init.c1)
          this.dbParams.push(new SQLField({ fieldName: "F_C1", value: init.c1 }));
      }
      
    }
  }
}